// Central place for support contact details so components never hardcode them.
export const CONTACT_CONFIG = {
  phoneDisplay: "+91 79934 16574",
  whatsappNumber: "917993416574",
  email: "satyanarayanarajavarma@gmail.com",
  whatsappDefaultMessage: "Hi, I need to talk about the WebPreview website.",
};

export function getWhatsappLink() {
  const text = encodeURIComponent(CONTACT_CONFIG.whatsappDefaultMessage);
  return `https://wa.me/${CONTACT_CONFIG.whatsappNumber}?text=${text}`;
}

export function getMailtoLink() {
  return `mailto:${CONTACT_CONFIG.email}`;
}
